import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-staron",
  "use": "icon-staron-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol viewBox=\"0 0 24 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-staron\">\n<path d=\"M12 17.76L4.94701 21.708L6.52201 13.78L0.587006 8.292L8.61401 7.34L12 0L15.386 7.34L23.413 8.292L17.478 13.78L19.053 21.708L12 17.76Z\" fill=\"#F7B653\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/staron.svg
// module id = uaQX
// module chunks = 111